export interface KHeaderWidget {
    backgroundColor?:      string;
    id:                    string;
    kHeaderWidgetActions?: KHeaderWidgetActions;
    kHeaderWidgetLogo?:    KHeaderWidgetLogo;
    shareWithConfig?:      boolean;
}

export interface KHeaderWidgetActions {
    kHeaderWidgetActionsBasket?:       KHeaderWidgetActionsBasket;
    kHeaderWidgetActionsCustomLinks?:  LocaleLinkWithIconSchema[];
    kHeaderWidgetActionsHome?:         KHeaderWidgetActionsHome;
    kHeaderWidgetActionsLangSelector?: KHeaderWidgetActionsLangSelector;
    kHeaderWidgetActionsSearchBar?:    KHeaderWidgetActionsSearchBar;
    kHeaderWidgetActionsUser?:         KHeaderWidgetActionsUser;
}

export interface KHeaderWidgetActionsBasket {
    active?:          boolean;
    backgroundColor?: string;
    bulletActive?:    boolean;
    color?:           string;
}

export interface LocaleLinkWithIconSchema {
    iconKey?:      string;
    iconPosition?: IconPosition;
    linkByLocale?: LinkByLocale[];
    marginLeft?:   number;
    marginRight?:  number;
    openInNewTab?: boolean;
}

export enum IconPosition {
    Left = "left",
    Right = "right",
}

export interface LinkByLocale {
    href?:     string;
    label?:    string;
    linkType?: LinkType;
    locale?:   Locale;
    title?:    string;
}

export enum LinkType {
    Didomi = "DIDOMI",
    Folder = "FOLDER",
    Mail = "MAIL",
    URL = "URL",
}

export enum Locale {
    De = "de",
    En = "en",
    Es = "es",
    Fr = "fr",
    Hu = "hu",
    It = "it",
    Nl = "nl",
    Pl = "pl",
    Pt = "pt",
    Ro = "ro",
}

export interface KHeaderWidgetActionsHome {
    active?: boolean;
    color?:  string;
}

export interface KHeaderWidgetActionsLangSelector {
    active?: boolean;
    color?:  string;
}

export interface KHeaderWidgetActionsSearchBar {
    active?:            boolean;
    backgroundColor?:   string;
    fields?:            string[];
    inputBorderRadius?: string;
    textColor?:         string;
}

export interface KHeaderWidgetActionsUser {
    active?:                  boolean;
    color?:                   string;
    cookieConsentManagement?: boolean;
    loginButtonAutoConnect?:  boolean;
    nameActive?:              boolean;
}

export interface KHeaderWidgetLogo {
    alt?:                       TranslationSchema[];
    kHeaderWidgetLogoPosition?: KHeaderWidgetLogoPosition;
    kHeaderWidgetLogoSpacing?:  KHeaderWidgetLogoSpacing;
    link?:                      string;
    url?:                       TranslationResourceSchema[];
}

export interface TranslationSchema {
    empty?:      boolean;
    language:    Locale;
    ressources?: any;
    value?:      string;
}

export enum KHeaderWidgetLogoPosition {
    Center = "center",
    Left = "left",
    Right = "right",
}

export interface KHeaderWidgetLogoSpacing {
    bottom?: string;
    left?:   string;
    right?:  string;
    top?:    string;
}

export interface TranslationResourceSchema {
    language:  Locale;
    resource?: Resource;
    value?:    string;
}

export interface Resource {
    id?:  string;
    url?: string;
}
